"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.processCatValues = exports.mergeDataWithColor = exports.getLighterColor = exports.getCellOptions = exports.filterEmptyValues = exports["default"] = void 0;
var R = _interopRequireWildcard(require("ramda"));
var _color = _interopRequireDefault(require("color"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var DEFAULT_CELL_STROKE_WIDTH = 1;
var processCatValues = exports.processCatValues = function processCatValues(data) {
  var valueKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'value';
  return R.map(function (item) {
    return _objectSpread(_objectSpread({}, item), {}, {
      isAmount: !!item[valueKey]
    });
  }, data);
};
var filterEmptyValues = exports.filterEmptyValues = function filterEmptyValues(data) {
  var valueKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'value';
  return R.reject(function (item) {
    return !item[valueKey];
  }, data);
};
var getLighterColor = exports.getLighterColor = function getLighterColor(fullColor) {
  var perc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.9;
  return (0, _color["default"])(fullColor).fade(perc).string();
};
var getNegativeFill = function getNegativeFill(_ref) {
  var color = _ref.color,
    isActive = _ref.isActive;
  if (isActive) {
    return getLighterColor(color, 0.45);
  }
  return getLighterColor(color, 0.98);
};
var mergeDataWithColor = exports.mergeDataWithColor = function mergeDataWithColor() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var colorValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return data.map(function (item, idx) {
    return _objectSpread(_objectSpread({}, item), {}, {
      color: colorValues[idx % colorValues.length]
    });
  });
};
var getCellOptions = exports.getCellOptions = function getCellOptions(_ref2) {
  var entry = _ref2.entry,
    labelKey = _ref2.labelKey,
    activeIndex = _ref2.activeIndex,
    index = _ref2.index;
  var cellOptions = {
    key: "cell-".concat(entry[labelKey]),
    fill: entry.isNegative ? getNegativeFill({
      color: entry.color,
      isActive: activeIndex === index
    }) : entry.color,
    stroke: entry.color,
    strokeDasharray: entry.isNegative ? '2 2' : '',
    strokeWidth: DEFAULT_CELL_STROKE_WIDTH
  };
  if (activeIndex !== -1 && activeIndex !== index) {
    cellOptions.fill = getLighterColor(entry.color);
    cellOptions.stroke = 0;
  }
  return cellOptions;
};
var _default = exports["default"] = {
  filterEmptyValues: filterEmptyValues
};